/* eslint-disable no-restricted-globals */
import ZoomVideo from '@zoom/videosdk';
import { Amplify } from 'aws-amplify';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import {
  COOKIE_DOMAIN,
  REACT_APP_COGNITO_REGION,
  REACT_APP_COGNITO_USER_POOL_CLIENT_ID,
  REACT_APP_COGNITO_USER_POOL_ID
} from './config/cognito';
import ZoomContext from './context/zoom-context';
import './index.css';
import { ChakraProvider, defaultSystem } from '@chakra-ui/react';
import reportWebVitals from './reportWebVitals';
import ErrorStateProvider from './context/error-state-context';

Amplify.configure({
  region: REACT_APP_COGNITO_REGION,
  userPoolId: REACT_APP_COGNITO_USER_POOL_ID,
  userPoolWebClientId: REACT_APP_COGNITO_USER_POOL_CLIENT_ID,
  Auth: {
    cookieStorage: {
      domain: COOKIE_DOMAIN,
      secure: true
    }
  }
});
const zmClient = ZoomVideo.createClient();
const root = createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <ZoomContext.Provider value={zmClient}>
      <ChakraProvider value={defaultSystem}>
        <ErrorStateProvider>
          <App />
        </ErrorStateProvider>
      </ChakraProvider>
    </ZoomContext.Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
